import createIcon from '../../createIcon';

/**
 * @component @name ViewHeadline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxNUgyMFYxM0g0VjE1Wk00IDE5SDIwVjE3SDRWMTlaTTQgMTFIMjBWOUg0VjExWk00IDVWN0gyMFY1SDRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewHeadline = createIcon('ViewHeadline', [
  [
    'path',
    { d: 'M4 15H20V13H4V15ZM4 19H20V17H4V19ZM4 11H20V9H4V11ZM4 5V7H20V5H4Z', key: '1uwox4' },
  ],
]);

export default ViewHeadline;
